<template>
  <section>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--列表-->
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      @selection-change="handleChoose"
      class="custom-tbl"
    >
      <el-table-column type="selection" width="50"> </el-table-column>
      <el-table-column type="index" width="80" label="序号"> </el-table-column>
      <el-table-column prop="MatchId" label="比赛Id"></el-table-column>
      <el-table-column prop="SessionId" label="场次Id"></el-table-column>
      <el-table-column label="票档名称" prop="GradeName"></el-table-column>
      <el-table-column label="单笔订单限购数量" prop="Limit"></el-table-column>
      <el-table-column label="票档价格" prop="Price"></el-table-column>
      <el-table-column label="剩余票数" prop="Remainder"></el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="mt16">
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 30, 40, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </div>
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="140px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select
            v-model="addForm.MatchId"
            @change="getSession(addForm.MatchId)"
          >
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次信息" prop="SessionId" v-if="addForm.MatchId">
          <el-select v-model="addForm.SessionId">
            <el-option
              v-for="item in sessionList"
              :key="item.Id"
              :label="item.SessionInfo"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="票档名称" prop="GradeName">
          <el-input
            v-model="addForm.GradeName"
            placeholder="请输入票档名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="单笔订单限购数量" prop="Limit">
          <el-input-number
            v-model="addForm.Limit"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="票价" prop="Price">
          <el-input-number
            v-model="addForm.Price"
            :min="0"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="剩余票数" prop="Remainder">
          <el-input-number
            v-model="addForm.Remainder"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="140px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="对应比赛" prop="MatchId">
          <el-select
            v-model="editForm.MatchId"
            @change="getSession(editForm.MatchId)"
          >
            <el-option
              v-for="item in matchList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="场次信息" prop="SessionId" v-if="editForm.MatchId">
          <el-select v-model="editForm.SessionId">
            <el-option
              v-for="item in sessionList"
              :key="item.Id"
              :label="item.SessionInfo"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="票档名称" prop="GradeName">
          <el-input
            v-model="editForm.GradeName"
            placeholder="请输入票档名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="单笔订单限购数量" prop="Limit">
          <el-input-number
            v-model="editForm.Limit"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="票价" prop="Price">
          <el-input-number
            v-model="editForm.Price"
            :min="0"
            :step="0.01"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="剩余票数" prop="Remainder">
          <el-input-number
            v-model="editForm.Remainder"
            :min="0"
            :step="1"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  matchListAll,
  ticketList,
  addTicket,
  deleteTicket,
  updateTicket,
  batchDeleteTicket,
  matchSessionList,
} from "@/api/match/match";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      listLoading: false,
      total: 0,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {},
      //新增界面数据
      addForm: {},
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {},
      //编辑界面数据
      editForm: {},
      matchList: [],
      idList: [],
      sessionList: [],
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
    this.getMatch();
  },
  methods: {
    handleDel(row) {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          return deleteTicket({
            id: row.Id,
          });
        })
        .then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getList();
          }
        });
    },
    handleEdit(row) {
      this.editForm = Object.assign({}, row);
      this.editFormVisible = true;
      this.getSession(row.MatchId);
    },
    handleAdd() {
      this.addForm = {};
      this.addFormVisible = true;
    },
    editSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          let para = Object.assign({}, this.editForm);
          updateTicket(para).then((res) => {
            this.editLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["editForm"].resetFields();
              this.editFormVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          addTicket(para).then((res) => {
            this.addLoading = false;
            if (res.data.success) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.$refs["addForm"].resetFields();
              this.addFormVisible = false;
              this.initPage();
              this.getList();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    getSession(id) {
      matchSessionList({
        matchId: id,
        page: 1,
        intPageSize: 999,
      }).then((res) => {
        this.$nextTick(() => {
          this.sessionList = res.data.response.data;
        });
      });
    },
    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    handleChoose(e) {
      this.idList = e.map((item) => item.Id);
    },
    handleBatchDelete() {
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          return batchDeleteTicket({
            ids: this.idList,
          });
        })
        .then((res) => {
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.initPage();
            this.getList();
          }
        });
    },  
    getList() {
      this.listLoading = true;
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
      };
      ticketList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    getMatch() {
      matchListAll().then((res) => {
        this.matchList = res.data.response;
      });
    },
  },
};
</script>
<style scoped>
</style>